export const tr = {
    'add-placements': {
        one: 'Kapsamı geliştirmek için {formats} formatında reklam yüzeyleri ekleyin',
        some: 'Kapsamı geliştirmek için {formats} formatlarında reklam yüzeyleri ekleyin',
        many: 'Kapsamı geliştirmek için {formats} formatlarında reklam yüzeyleri ekleyin',
        none: 'Kapsamı geliştirmek için {formats} formatlarında reklam yüzeyleri ekleyin'
    },
    'ratio-info': {
        one: '{count} kreatif için {format}',
        some: '{count} kreatif için {format}',
        many: '{count} kreatif için {format}',
        none: '{count} kreatif için {format}'
    },
    title: 'Uygun formatlarda panolar ekleyin',
    'title-hint': 'Seçilen kreatifler için uygun panolar olmadığı için öneri gösterilir',
    'video-format': '{width}×{height} → {duration} sn.'
};
